




































































import moment from "moment";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { DbUtile, ResultDbCourseManagement, ResultDbCourseManagementDetails } from "../database/DbUtile";
import { DbCourseManagement, DbCourseManagementDetails } from "../database/DbCourseManagement";

@Component({
  filters: {
    moment(value: string, format: string) {
      if (value == "") {
        return "---";
      }
      return moment(value).format(format);
    }
  }
})
export default class AttendanceDetailsTable extends Vue {
  @Prop() title?: string;
  @Prop() status?: string;
  @Prop() admin?: boolean;
  @Prop() isSort?: boolean;

  @Prop() courseManagementId?: string;
  @Prop() rows?: ResultDbCourseManagementDetails[];

  @Prop() isFrom?: boolean;

  @Prop() now!: Date;

  created() {
    console.log('created', this.rows);
    console.log('isFrom', this.isFrom!);
  }

  // 期限チェック
  isExpired(f: string, t: string): boolean {
    // 現在日時
    const from = new Date(f);
    const to = new Date(t);
    // 配信終了（現在日時 > 終了日時）
    if (this.now > to) {
      return true;
    }
    return false;
  }

  linkLabel(f: string, t: string): string {
    let result = "本日開催";
    /*
    開始日=今日 → 本日開催（別の色で強調）
    開始日=明日 → 明日
    開始日=今週中 → 今週
    その他 → ○日後
    配信終了 =（現在日時 > 終了日時）
    */
    const now = moment(new Date(this.now)).format("YYYY-MM-DD");
    const from = moment(new Date(f)).format("YYYY-MM-DD");
    const nextDay = moment(new Date(this.now)).add(1, 'd').format("YYYY-MM-DD");
    const to = moment(new Date(t)).format("YYYY-MM-DD");
    if (this.isExpired(f, t) == true) {
      result = "<p class='button'>配信終了</p>";
    }
    else{
      if ((this.status == "") || (this.status == "during")){
        if (from == now) {
          console.log("now", now);
          result = "<p class='button is-danger'>本日開催</p>";
        }
        else if (from == nextDay) {
          result = "<p class='button is-info'>明日</p>";
        }
        // TODO 今週中 → 今週 週表記 計算困難 なので未実装
        else {
          // ○日後
          const days = moment(from).diff(moment(now), "days");
          if (days > 0) {
            result = "<p class='button is-info'>" + days + "日後</p>";
          }
          else {
            result = "<p class='button is-primary'>受講中</p>";
          }
        }
      }
      else if (this.status == "done"){
        result = "<p class='button is-info'>完了</p>";
      }
      else if (this.status == "expired"){
        result = "<p class='button'>配信終了</p>";
      }
    }
    return result;
  }

  // 受講画面へ遷移する
  clickToAttend(data: ResultDbCourseManagementDetails) {
    console.log("clickToAttend", data.id, this.admin);
    if (this.admin == false){
      const now = new Date(this.now);
      const from = new Date(data.courseManagementDetails!.from);

      const f = "YYYY-MM-DD";
      const nowStr = moment(now).format(f);
      const fromStr = moment(new Date(from)).format(f);
      if (this.isExpired(data.courseManagementDetails!.from, data.courseManagementDetails!.to) == true) {
        // 期限切れの場合
        return
      }
      if (from > now) {
        // 日時が一致する場合 以外はリンクさせない
        if (nowStr == fromStr) {
          alert(`開催日時を確認してください`);
        }
        return;
      }
    }
    const isAdmin = this.admin ? 'true' : 'false';
    this.$router.push({ name: 'StartOfCourse', params: { id: this.courseManagementId!, did: data.id!, admin: isAdmin} });
  }
}
